import { Lock } from 'lucide-react';
import { memo, type ReactNode } from 'react';

import { LockedFeatureTooltip } from './LockedFeatureTooltip';

export type LockedTabLabelProps = {
  locked: boolean;
  children: ReactNode;
  message?: string;
};

export const LockedTabLabel = memo(function LockedTabLabel({
  locked,
  children,
  message,
}: LockedTabLabelProps) {
  return (
    <span className='inline-flex items-center gap-1.5'>
      {children}
      {locked && (
        <LockedFeatureTooltip locked message={message}>
          <span className='inline-flex'>
            <Lock className='size-3.5 shrink-0 opacity-60' aria-hidden />
          </span>
        </LockedFeatureTooltip>
      )}
    </span>
  );
});
